import { render } from "./MergeList.vue?vue&type=template&id=6edb5e40"
import script from "./MergeList.vue?vue&type=script&lang=js"
export * from "./MergeList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__